import React from "react";
import styled from "styled-components";
import { connect } from "react-redux";

const ContactList = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  justify-items: center;
  gap: 30px;

  @media screen and (max-width: ${(prop) =>
    prop.theme.screenSizes.breakLarge}) {
    grid-template-columns: 1fr 1fr;
  }

  @media screen and (max-width: ${(prop) =>
    prop.theme.screenSizes.breakTabletMedium}) {
    grid-template-columns: 1fr;
    width: 110%;
  }
`;
const Contact = styled.div`
  display: inline-block;
  width: 310px;
  padding: 20px 10px 10px;
  border-radius: 8px;
  border: 1px solid #DFDFDF;
  background: #fff;
  box-shadow: 3px 3px 6px 0px rgba(169, 169, 169, 0.25);

  @media screen and (max-width: ${(prop) =>
    prop.theme.screenSizes.breakLarge}) {
    width: 335px;
  }

  @media screen and (max-width: ${(prop) =>
    prop.theme.screenSizes.breakSmall}) {
    width: 100%;
  }
`;
const Label = styled.div`
  display: inline-block;
  border-radius: 20px;
  border: 1px solid;
  border-color: ${(prop) => prop.color};
  padding: 4px 15px;
  color: ${(prop) => prop.color};
  font-size: 12px;
  font-family: 'Poppins', sans-serif;
  font-weight: 500;
  text-transform: capitalize;
`;

const Title = styled.div`
  color: var(--primary-dark-blue, #0f0538);
  text-align: center;
  font-family: Poppins, sans-serif;
  font-size: 24px;
  font-weight: 500;
  // line-height: 1;
  padding-top: 10px;
  text-transform: capitalize;
`;

const Availablility = styled.div`
  color: var(--primary-blue, #42accd);
  font-family: DM Sans;
  font-size: 12px;
  font-weight: 500;
  text-transform: capitalize;
  margin-bottom: 10px;
`;

const Details = styled.div`
  border-radius: 10px;
  border: 1px solid #f4f4f4;
  background: #fff;
  text-align: center;
  color: var(--secondary-gray-1, #495057);
  font-family: DM Sans;
  font-size: 11px;
  margin-bottom: 12px;

  ::first-letter {
    text-transform: capitalize;
  }
`;

const ContactsWrapper = styled.div`
  display: flex;
  justify-content: center;
  border-radius: 0px 0px 8px 8px;
  background: #fbfbfb;
  height: 75px;
  margin: 0 -10px -10px;
  align-items: center;

  .contact-group {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;

    img {
      width: 32px;
      margin-bottom: 5px;
    }

    .contact-info {
      font-size: 11px;
      color: #414B64;
      font-family: Poppins; 
    }
  }
`;

function Contacts({ data, newBranding }) {
  return (
    <ContactList>
      {data.map((contact, key) => {
        return (
          <Contact className="resident-contact" data={contact} key={key}>
            <Label color={contact.labelColor}>{contact.label}</Label>
            <Title className="resident-contact-title">{contact.title}</Title>
            <Availablility className="resident-contact-availability">{contact.availability}</Availablility>
            <Details className="resident-contact-details">{contact.details}</Details>
            <ContactsWrapper className="resident-contact-contacts-wrapper">
              {contact.phone && (  
                <div className="contact-group">  
                 <a href={"tel:" + contact.phone}> 
                  {newBranding && newBranding === "1" ? 
                    <img src="/images/phone-contact-green.svg" alt="phone" /> :
                    <img src="/images/phone-contact.svg" alt="phone" />
                  }            
                  </a>
                  <span className="contact-info">{contact.phone}</span>               
                </div>
              
              )}

              {contact.email && (
                <div className="contact-group">
                  <a href={"mailto:" + contact.email}>
                    {newBranding && newBranding === "1" ? 
                    <img src="/images/email-contact-green.svg" alt="phone" /> :
                    <img src="/images/email-contact.svg" alt="phone" />
                  }
                  </a>
                  <span className="contact-info">{contact.email}</span>
                </div>
              )}
            </ContactsWrapper>
          </Contact>
        );
      })}
    </ContactList>
  );
}

const mapStateToProps = (state) => ({
  newBranding: state.settings.new_branding,
});

export default connect(mapStateToProps)(Contacts);

